const routesLogin = [

	{
		path: '/login',
		name: 'Login',
		component: () => import('@/components/login/LoginForm.vue'),
		meta: {
			browserTitleKey: 'auth.login.login',
			descriptionKey: 'auth.login.accessMessage',
		},
	},
	{
		path: '/resetlogin',
		name: 'LoginReset',
		component: () => import('@/components/login/LoginReset.vue'),
		meta: { browserTitleKey: 'auth.login.forgotPassword' },
	},
	{
		path: '/activation',
		name: 'LoginActivation',
		component: () => import('@/components/login/LoginActivation.vue'),
		meta: { browserTitleKey: 'auth.accountActivation' },
	},
	{
		path: '/resetpassword',
		name: 'LoginResetPassword',
		component: () => import('@/components/login/LoginResetPassword.vue'),
		meta: { browserTitleKey: 'auth.passwordReset' },
	},
] as const;

export default routesLogin;
